import { snakeifyString } from '@rover/rsdk/src/modules/Network/object-utilities';
import { HomepageSearchFilters } from '@rover/types/src/HomepageSearchFilters';

export const TRAINING_SEARCH_PARAMETERS = [
  'location',
  'centerlat',
  'centerlng',
  'locationType',
  'locationAccuracy',
  'rawLocationTypes',
  'behaviors',
  'skills',
];

export const appendSearchQueryParams = (
  url: string,
  parametersDict: Partial<HomepageSearchFilters>
): string => {
  const searchParams = new URLSearchParams();
  for (const key of TRAINING_SEARCH_PARAMETERS) {
    const value = parametersDict[key];
    if (Array.isArray(value)) {
      searchParams.append(snakeifyString(key), value.join(','));
    } else if (typeof value === 'string') {
      searchParams.append(snakeifyString(key), value);
    }
  }
  const searchParamsString = searchParams.toString();
  if (searchParamsString) {
    return `${url}?${searchParams.toString()}`;
  }
  return url;
};
